/**
 * A special article is a one-off item (#556), never a shared article: it has no
 * article page, no price history and no best price. The key itself says so, the
 * same way `article:unresolved:` and `article:custom:` do.
 */
export const SPECIAL_ARTICLE_PREFIX = "article:special:";

export function isSpecialArticleKey(key: string | null | undefined): boolean {
  return typeof key === "string" && key.startsWith(SPECIAL_ARTICLE_PREFIX);
}
